import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { RxCross2 } from "react-icons/rx";
import axios from "axios";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { authSlice } from "../Store/modules/AuthModule/authSlice";

const { actions } = authSlice;
const URL = process.env.REACT_APP_BASE_URL || "https://api.careerroshi.com";

const initialForm = {
  currentPassword: "",
  newPassword: "",
  confirmedPassword: "",
};

function ChangePasswordModal({ show, handleClose }) {
  const dispatch = useDispatch();
  const { accessToken, user } = useSelector(({ auth }) => auth, shallowEqual);

  const [form, setForm] = useState(initialForm);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
    setError("");
  };

  const handleHide = () => {
    if (pending) return;
    setForm(initialForm);
    setError("");
    handleClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!form.currentPassword) {
      setError("Current password is required.");
      return;
    }
    if (!form.newPassword) {
      setError("New password is required.");
      return;
    }
    if (!form.confirmedPassword) {
      setError("Please confirm your new password.");
      return;
    }
    if (form.newPassword !== form.confirmedPassword) {
      setError("New password and confirm password do not match.");
      return;
    }

    try {
      setPending(true);
      await axios.put(
        `${URL}/user/update-password/${user.id}`,
        {
          currentPassword: form.currentPassword,
          newPassword: form.newPassword,
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      setForm(initialForm);
      handleClose();
    } catch (ex) {
      if (ex.response?.status === 401) {
        dispatch(actions.logout());
        return;
      }
      const message =
        ex.response?.data?.message || ex.message || "Something went wrong.";
      setError(message);
    } finally {
      setPending(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleHide}
      centered
      backdrop={pending ? "static" : true}
    >
      <Modal.Header className="d-flex justify-content-between align-items-center">
        <Modal.Title>Change Password</Modal.Title>
        <button
          className="bg-transparent border-0"
          onClick={handleHide}
          disabled={pending}
        >
          <RxCross2 />
        </button>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && (
            <div className="alert alert-danger py-2 px-3 mb-3" role="alert">
              {error}
            </div>
          )}

          <Form.Group className="mb-3">
            <Form.Label className="font-weight-bold">Current Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter current password"
              value={form.currentPassword}
              onChange={handleChange("currentPassword")}
              disabled={pending}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="font-weight-bold">New Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter new password"
              value={form.newPassword}
              onChange={handleChange("newPassword")}
              disabled={pending}
            />
          </Form.Group>

          <Form.Group className="mb-1">
            <Form.Label className="font-weight-bold">Confirm New Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Confirm new password"
              value={form.confirmedPassword}
              onChange={handleChange("confirmedPassword")}
              disabled={pending}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleHide} disabled={pending}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={pending}>
            {pending ? (
              <span className="spinner-border spinner-border-sm" role="status" />
            ) : (
              "Update Password"
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ChangePasswordModal;
